import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const fieldManagementRoutes = [
  {
    path: 'field-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.FieldsView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/fieldManagement/list/FieldListView.vue'),
        meta: { permissionAction: PermissionActions.FieldsView },
      },
      {
        path: ':fieldId',
        component: () =>
          import('@/features/settingsManagement/fieldManagement/edit/FieldEditView.vue'),
        meta: { permissionAction: PermissionActions.FieldsView },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/fieldManagement/edit/FieldEditView.vue'),
        meta: { permissionAction: PermissionActions.FieldsCreate },
      },
    ],
  },
]
